import React, { useGlobal } from 'reactn';
import { Redirect } from "react-router-dom";

function Entity() {
  // const [ sUserName ] = useGlobal('sUserName');
  // const [ sUserEmail ] = useGlobal('sUserEmail');
  
  const [bAuth] = useGlobal('bAuth');
  
  if (bAuth) {
    return <Redirect to="/my_document" />;
  } else {
    return <Redirect to="/login" />;
  }

  // return (
  //   <div>
  //     <span style={{ marginRight: 10 }}>{sUserName}</span>
  //     <span>({sUserEmail})</span>
  //   </div>
  // );
}

export default Entity;